import './new-job-grade.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateJobGrade } from "@core/query/job-grade.query";
import { JobGradeFormRule, JobGradeFormSchema } from "@core/form/form.rule";
import { jobGradeFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormJobGrade from "../form-job-grade/form-job-grade";

export function JobGrade() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateJobGrade } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New JobGrade is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addJobGrade, isLoading: isCreating } =
    useQyCreateJobGrade(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<JobGradeFormSchema>({
    defaultValues: jobGradeFormDefault,
    resolver: zodResolver(JobGradeFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: JobGradeFormSchema) => {
    const formData = mapCreateJobGrade(form);
    addJobGrade(formData);
  };
  const handleValidateError = (err: FieldErrors<JobGradeFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="JobGrade" className="job-grade">
      <HeaderContent
        title="New JobGrade"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormJobGrade />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default JobGrade;